var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"caption"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"body-1",staticStyle:{"white-space":"pre-line"}},[_vm._v(" "+_vm._s(_vm.toDisplay(_vm.value) || '-')+" ")]),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }